/**
 * The customer accounts a vehicle can be moved to.
 *
 * Excludes the one it already belongs to, since selecting that is a write with no
 * change. The comparison is normalised because the current name arrives as a
 * coalesce of `fleetIDMap.fleetName` and the denormalised copy on configBOP, and
 * those two can differ in case or spacing for the same customer. An exact compare
 * would leave the vehicle's own customer in the list looking like a different one.
 *
 * With no current name - an older backend, or a vehicle with no configBOP row -
 * there is nothing to exclude, so every option is offered rather than none.
 */
const normalise = (value) => (value || "").trim().toLowerCase();

export const customerAccountOptions = (fleets = [], currentFleetName) => {
  const current = normalise(currentFleetName);
  if (!current) return fleets;
  return fleets.filter((fleet) => normalise(fleet?.name) !== current);
};
